import authHeader from "@/services/auth/AuthHeader";
import axios from "axios";

/**
 * VIVA payments pulled from VIVA's own APIs with CAGISTA's ISV credentials. Payouts are not among them: VIVA keeps
 * them merchant-level (2026-10-22), so «Utbetalinger» sends the owner to their VIVA account instead.
 *
 * Not to be confused with /vivaTransactions, which reads locally stored viva transaction documents for a
 * single merchant + location out of Couchbase, for reconciliation. Different data, different source.
 */
class VivaReportService {
    /**
     * «Kortbetalinger»: one merchant's VIVA payments on one day — EMPLOYEE, ADMIN and SUPER_ADMIN. The server keeps
     * only that merchant's own transactions and refuses any merchant but the caller's.
     *
     * @param params {merchant, date: 'yyyy-MM-dd', timeFrom?: 'HH:mm', timeTo?: 'HH:mm', amount?: '349,50'}
     */
    findPayments(params){
        return axios.get('/api/payment/findVivaPayments', { params: params, headers: authHeader() });
    }

    /**
     * «Regnskapsbilag»: VIVA's card settlement per clearing day for one of the merchant's VIVA accounts — ADMIN,
     * ACCOUNTANT and SUPER_ADMIN, not EMPLOYEE. Amounts come back in øre, signed as money into the VIVA account.
     *
     * @param params {merchant, from: 'yyyy-MM-dd', to: 'yyyy-MM-dd', locationId?: a location on the VIVA account}
     */
    getSettlement(params){
        return axios.get('/api/report/getVivaSettlement', { params: params, headers: authHeader() });
    }

    /**
     * Runs the archive of VIVA's settlement days now, as the night does — SUPER_ADMIN only. Without dates it picks up
     * where each account's archive stops being locked; a locked day is never written again.
     */
    archiveSettlements(){
        return axios.post('/api/superadmin/viva/archiveSettlements', null, { headers: authHeader() });
    }
}

export default new VivaReportService();
